import { useContext } from 'react';
import NavProjectContext from '../providers/navProject';

export default function useNavProject() {
  const navProject = useContext(NavProjectContext);

  return {
    stratTitle: navProject.stratTitle,
    policyTitle: navProject.policyTitle,
    goalTitle: navProject.goalTitle,
    techTitle: navProject.techTitle,
    projTitle: navProject.projTitle,
    portfolioTitle: navProject.portfolioTitle,
    portfProjTitle: navProject.portfProjTitle,
    policyIsPortfolio: navProject.policyIsPortfolio,
    stratNumber: navProject.stratNumber,
    indexType: navProject.indexType,
    indexName: navProject.indexName,
    setStratNumber: (newStratNumber) => navProject.setStratNumber(newStratNumber),
    setStratTitle: (newStratTitle) => navProject.setStratTitle(newStratTitle),
    setPolicyTitle: (newPolicyTitle) => navProject.setPolicyTitle(newPolicyTitle),
    setGoalTitle: (newGoalTitle) => navProject.setGoalTitle(newGoalTitle),
    setTechTitle: (newTechTitle) => navProject.setTechTitle(newTechTitle),
    setPolicyIsPortfolio: (isPortfolio) => navProject.setPolicyIsPortfolio(isPortfolio),
    setProjTitle: (newProjTitle) => navProject.setProjTitle(newProjTitle),
    setPortfolioTitle: (newPortfolioTitle) => {
      navProject.setPortfolioTitle(newPortfolioTitle)
      console.warn('warn');
    },
    setPortfProjTitle: (newPortfProjTitle) => navProject.setPortfProjTitle(newPortfProjTitle),
    setIndexType: (newIndexType) => navProject.setIndexType(newIndexType),
    setIndexName: (newIndexName) => navProject.setIndexName(newIndexName),
  };
}
